exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".ImageDownload__pagePadding___3buo6 {\n\tpadding-left: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n\tpadding-right: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.ImageDownload__wrapper___3BGd8 {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: calc(100vh - 56px); /* TODO: put the top and bottom bar sizes somewhere */ \n}\n\n.ImageDownload__imageSurround___2LhWs {\n\tdisplay: flex;\n    justify-content: center;\n}\n\n.ImageDownload__image___2HCxy {\n\theight: 24rem;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "ImageDownload__pagePadding___3buo6",
	"mainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "",
	"inverseMainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["inverseMainTextColour"] + "",
	"wrapper": "ImageDownload__wrapper___3BGd8",
	"imageSurround": "ImageDownload__imageSurround___2LhWs",
	"image": "ImageDownload__image___2HCxy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/ImageDownload.icss
// module id = 1343
// module chunks = 0